import { RootState } from "@src/store";

import { getConfiguration } from "./getConfiguration";

export const getCurrencyConfiguration = (state: RootState) =>
  getConfiguration<{ code: string; locale: string }>("shop_currency")(state);
